import { type Dispatch, type SetStateAction, useEffect } from 'react'

import { TransformComponent, TransformWrapper } from '@pronestor/react-zoom-pan-pinch'
import { Icon } from 'components'

import * as S from './styles'

type ImageViewerProps = {
  title: string | React.ReactElement
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  fileUrl: string
}

export const ImageViewer = ({ title, open, setOpen, fileUrl }: ImageViewerProps) => {
  useEffect(() => {
    function handleCloseByKeyUpEscape(event: KeyboardEvent) {
      if (event.key === 'Escape' && open) {
        setOpen(false)
      }
    }

    window.addEventListener('keyup', handleCloseByKeyUpEscape)

    return () => {
      window.removeEventListener('keyup', handleCloseByKeyUpEscape)
    }
  }, [open])

  return (
    <>
      {open && (
        <S.Wrapper>
          <S.Content>
            <S.TitleRow>
              <S.Title>{title}</S.Title>
              <S.CloseButton onClick={() => setOpen(false)}>
                <Icon icon="close" size="28" />
              </S.CloseButton>
            </S.TitleRow>
            <TransformWrapper centerOnInit>
              <TransformComponent>
                <img alt="Imagem anexada" src={fileUrl} />
              </TransformComponent>
            </TransformWrapper>
          </S.Content>
        </S.Wrapper>
      )}
    </>
  )
}
